import { GET_OWN, SEQUENCE_UPDATE } from "shared/constants/ActionTypes";

const initialState = {
    own: [],
    sequenceUpdate: null
}

const SequenceReducer = (state=initialState,action) => {
    switch (action.type) {
        case GET_OWN:
            return {
                ...state,
                own: action.payload
            }
        case SEQUENCE_UPDATE:
            return {
                ...state,
                sequenceUpdate: action.payload
            }
        default:
            return {
                ...state
            }
        }
    };

export default SequenceReducer